module.exports = __webpack_public_path__ + "static/media/centerWheel.6368a647.svg";